/**
 * Климатические данные регионов России для расчета теплопотерь
 * 
 * designTemp - расчетная температура наружного воздуха для проектирования отопления (°C)
 * avgTemp - среднегодовая температура (°C)
 * heatingDays - продолжительность отопительного периода (дней)
 * GSOP - градусо-сутки отопительного периода (°C*сут)
 */

export const climateData = {
  
    // Приволжский федеральный округ
    'nizhny_novgorod': {
      name: 'Нижний Новгород',
      designTemp: -31,
      avgTemp: 4.1,
      heatingDays: 215,
      GSOP: 5104
    },
    'kazan': {
      name: 'Казань',
      designTemp: -32,
      avgTemp: 4.2,
      heatingDays: 215,
      GSOP: 5188
    },
    'samara': {
      name: 'Самара',
      designTemp: -30,
      avgTemp: 5.2,
      heatingDays: 203,
      GSOP: 4794
    },
    'perm': {
      name: 'Пермь',
      designTemp: -35,
      avgTemp: 2.3,
      heatingDays: 229,
      GSOP: 5984
    },
    'ufa': {
      name: 'Уфа',
      designTemp: -33,
      avgTemp: 3.4,
      heatingDays: 213,
      GSOP: 5348
    },
    'saratov': {
      name: 'Саратов',
      designTemp: -27,
      avgTemp: 6.4,
      heatingDays: 196,
      GSOP: 4231
    },
    
    // Уральский федеральный округ
    'yekaterinburg': {
      name: 'Екатеринбург',
      designTemp: -35,
      avgTemp: 2.6,
      heatingDays: 230,
      GSOP: 6166
    },
    'chelyabinsk': {
      name: 'Челябинск',
      designTemp: -34,
      avgTemp: 2.8,
      heatingDays: 218,
      GSOP: 5720
    },
    'tyumen': {
      name: 'Тюмень',
      designTemp: -38,
      avgTemp: 1.7,
      heatingDays: 225,
      GSOP: 6344
    },
    'kurgan': {
      name: 'Курган',
      designTemp: -37,
      avgTemp: 2.3,
      heatingDays: 216,
      GSOP: 6021
    },
    'surgut': {
      name: 'Сургут',
      designTemp: -43,
      avgTemp: -1.1,
      heatingDays: 257,
      GSOP: 7954
    },
    
    // Сибирский федеральный округ
    'novosibirsk': {
      name: 'Новосибирск',
      designTemp: -39,
      avgTemp: 1.3,
      heatingDays: 230,
      GSOP: 6601
    },
    'omsk': {
      name: 'Омск',
      designTemp: -37,
      avgTemp: 1.6,
      heatingDays: 220,
      GSOP: 6325
    },
    'krasnoyarsk': {
      name: 'Красноярск',
      designTemp: -40,
      avgTemp: 0.5,
      heatingDays: 235,
      GSOP: 7175
    },
    'irkutsk': {
      name: 'Иркутск',
      designTemp: -36,
      avgTemp: -0.4,
      heatingDays: 240,
      GSOP: 7586
    },
    'tomsk': {
      name: 'Томск',
      designTemp: -41,
      avgTemp: 0.5,
      heatingDays: 236,
      GSOP: 7285
    },
    'barnaul': {
      name: 'Барнаул',
      designTemp: -39,
      avgTemp: 2.0,
      heatingDays: 218,
      GSOP: 6525
    },
    
    // Дальневосточный федеральный округ
    'vladivostok': {
      name: 'Владивосток',
      designTemp: -24,
      avgTemp: 4.9,
      heatingDays: 196,
      GSOP: 4389
    },
    'khabarovsk': {
      name: 'Хабаровск',
      designTemp: -34,
      avgTemp: 1.4,
      heatingDays: 217,
      GSOP: 6065
    },
    'yakutsk': {
      name: 'Якутск',
      designTemp: -52,
      avgTemp: -8.8,
      heatingDays: 252,
      GSOP: 10524
    },
    'magadan': {
      name: 'Магадан',
      designTemp: -31,
      avgTemp: -3.4,
      heatingDays: 278,
      GSOP: 8170
    },
    'blagoveshchensk': {
      name: 'Благовещенск',
      designTemp: -35,
      avgTemp: 0.1,
      heatingDays: 212,
      GSOP: 7034
    },
    'petropavlovsk_kamchatsky': {
      name: 'Петропавловск-Камчатский',
      designTemp: -20,
      avgTemp: 1.9,
      heatingDays: 235,
      GSOP: 5763
    },
    
    // Крым
    'simferopol': {
      name: 'Симферополь',
      designTemp: -15,
      avgTemp: 10.8,
      heatingDays: 158,
      GSOP: 2163
    },
    'sevastopol': {
      name: 'Севастополь',
      designTemp: -11,
      avgTemp: 12.1,
      heatingDays: 137,
      GSOP: 1739
    },
    
    // Произвольный регион (для ручного ввода)
    'custom': {
      name: 'Другой город',
      designTemp: -25,
      avgTemp: 4.0,
      heatingDays: 200,
      GSOP: 4500
    }
  };